import { UserHistory } from "../../components";

export const AdminMembersUserHistory = () => {
  return (
    <>
      <UserHistory isAdmin={true} />
    </>
  );
};
